export interface ICompany {
  id: number;
  name: string;
}
export class Company implements ICompany {
  constructor(public id: number = 0, public name: string = '') {}
}
